module.exports = __webpack_public_path__ + "img/icons_39.138553c3.svg";